import React from 'react';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';
import MapSelection from '../../../../../components/MapSelection';
import { styleConfigs } from '../../../../../utils/mapbox/style_configs';
import { configMapSelectionSections } from '../../../../../utils/map_selection_helpers';

const createReactClass = require('create-react-class');

const hotkeysHash = {
  87: 'worldparks', // w
  69: 'openstreet', // e
  84: 'topo', // t
  83: 'alltrailsSatellite', // s
  65: 'arcgisSatellite', // a
  82: 'roadmap', // r
  68: 'worldtopo', // d
  81: 'opencycle', // q
  70: 'alltrailsOutdoorsV2' // f
};

const IconMapLayerSelection = createReactClass({
  getSections() {
    const layerSections = [
      {
        key: 'layers',
        header: null,
        cardKeys: [
          'alltrailsOutdoorsV2',
          'roadmap',
          'alltrailsSatellite',
          'topo',
          'worldtopo',
          'worldparks',
          'openstreet',
          'opencycle',
          'arcgisSatellite'
        ]
      }
    ];
    return configMapSelectionSections(layerSections, styleConfigs, this.props.permissions, this.getCardImg, this.isCardSelected);
  },
  getCardImg(layer) {
    return `https://cdn-assets.alltrails.com/assets/map-layers/v2/map-layer-${layer}@2x.png`;
  },
  isCardSelected(layer) {
    return this.props.currentMapLayer === layer;
  },
  render() {
    return (
      <MapSelection
        adminLayout={this.props.context && this.props.context.adminUser}
        closeOnCardClick
        getCTAFooterConfig={null}
        handleCardClick={this.props.handleCardClick}
        hotkeysHash={hotkeysHash}
        getSections={this.getSections}
        taller={false}
        title={StringConstantsMixin.strings.MAP_LAYERS}
        type="layer"
      />
    );
  }
});

export { IconMapLayerSelection };
